import { render, staticRenderFns } from "./EditApotIncidentForm.vue?vue&type=template&id=0fa9fb1e&scoped=true&"
import script from "./EditApotIncidentForm.vue?vue&type=script&lang=js&"
export * from "./EditApotIncidentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9fb1e",
  null
  
)

export default component.exports